import { useState } from "react";
import { RequestState, IRequestContext } from "./RequestContext";

export const useRequest = (
  successStatuses = [200, 201, 202, 203, 204],
  defaultErrorMessage = "Nobody expects the Spanish Inquisition",
): IRequestContext => {
  const [state, setState] = useState<RequestState>(RequestState.Idle);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    defaultErrorMessage,
  );

  const send = async (
    promise: Promise<any>,
    onSuccess?: (response: any | undefined) => void,
    onError?: (error: Error) => void,
  ): Promise<any> => {
    if (state === RequestState.Fetching) {
      return null;
    }

    setState(RequestState.Fetching);
    try {
      const response = await promise;
      if (successStatuses.includes(response.status)) {
        if (onSuccess != null) {
          onSuccess(response.data);
        }
        setErrorMessage(undefined);
        setState(RequestState.Finished);

        return response.data;
      }
      throw new Error("API error");
    } catch (error: any) {
      if (onError != null) {
        if (error instanceof Error) {
          onError(error);
        } else {
          const data = error?.data ?? error?.response?.data;
          const errString = JSON.stringify(
            data?.non_field_errors ?? data ?? error,
          );
          onError(new Error(errString.slice(0, 250)));
        }
      }
      setErrorMessage(
        (error as any)?.response?.data?.non_field_errors ?? defaultErrorMessage,
      );
      setState(RequestState.Error);
    }

    return null;
  };

  return {
    state,
    errorMessage,
    send,
    setState,
  };
};
